export default "__VITE_ASSET__qomzyYFF__"